import React from "react";
import styles from "./services.module.css";
import { useEffect } from "react";
import { useState } from "react";
import { useRef } from "react";
import { ReactComponent as Acc } from "../../../../../assests/service_hh/e-commerce_2-line-75.svg";
import { ReactComponent as Add } from "../../../../../assests/service_hh/Communication_1-line-35.svg";
import { ReactComponent as Log } from "../../../../../assests/service_hh/e-commerce_2-line-64.svg";
import { ReactComponent as Ess } from "../../../../../assests/service_hh/Communication_1-line-37.svg";
import { ReactComponent as Food } from "../../../../../assests/service_hh/social_line-4.svg";
import { ReactComponent as Sup } from "../../../../../assests/service_hh/edition_1-line-88.svg";
import { ReactComponent as Logi } from "../../../../../assests/service_hh/social_line-68.svg";
function Services() {
  const pRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (pRef.current) {
      observer.observe(pRef.current);
    }

    return () => {
      if (pRef.current) {
        observer.unobserve(pRef.current);
      }
    };
  }, []);

  return (
    <div className={styles.services_wrapper}>
      {/* <div className={styles.services_top}></div> */}
      {/* <div className={styles.services_middle}></div> */}
      {/* <div className={styles.services_bottom}></div> */}
      <div id="services" className={styles.services_container}>
        <div
          ref={pRef}
          className={`${styles.servicesTitle} ${isVisible ? styles.show : ""}`}>
          <h2>
            Services <span>Highlights</span>
          </h2>
          <p>Our Experience & Know-How</p>
          <div className={styles.servicesLine}></div>
        </div>
        <div className={styles.servicesCardWrapper}>
          <div
            ref={pRef}
            className={`${styles.upperCard} ${isVisible ? styles.show : ""}`}>
            <div className={styles.accounting}>
              <Acc className={styles.globalIcon} width={50} height={50} />
              <h2>Accounting</h2>
              <p>
                Comprehensive financial management for accurate reporting and
                compliance.
              </p>
            </div>
            <div className={styles.essentials}>
              <Ess className={styles.globalIcon} width={50} height={50} />
              <h2>Essentials</h2>
              <p>
                Supplying necessary goods and resources for everyday business
                operations.
              </p>
            </div>
            <div className={styles.foodsGoods}>
              <Food className={styles.globalIcon} width={50} height={50} />
              <h2>Foods & Goods</h2>
              <p>
                Reliable sourcing and distribution of quality food and products.
              </p>
            </div>
          </div>
          <div
            ref={pRef}
            className={`${styles.lowerCard} ${isVisible ? styles.show : ""}`}>
            <div className={styles.administration}>
              <Add className={styles.globalIcon} width={50} height={50} />
              <h2>Administration</h2>
              <p>
                Support for students, including resources, guidance, and
                education assistance.
              </p>
            </div>
            <div className={styles.supply}>
              <Sup className={styles.globalIcon} width={50} height={50} />
              <h2>Supply</h2>
              <p>
                Streamlined logistics for efficient procurement and delivery of
                products.
              </p>
            </div>
            <div className={styles.consulting}>
              <Log className={styles.globalIcon} width={50} height={50} />
              <h2>Consulting</h2>
              <p>
                Expert advice to optimize strategies and drive business success.
              </p>
            </div>
            <div className={styles.logistics}>
              <Logi className={styles.globalIcon} width={50} height={50} />
              <h2>Logistics</h2>
              <p>
                Efficient Comprehensive handling of transport, storage,
                distribution
              </p>
            </div>
          </div>
        </div>
        {/* <button>
        <Link to={{ pathname: "https://solutioncorner.online" }} target="_blank">Click to open HereWeCode (new tab)</Link>
        </button> */}
      </div>
    </div>
  );
}

export default Services;
